import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  AdminStatsSectionNav,
  AdminStatsSectionNavItem,
} from '@/app/pages/admin-options/settings/molecules/admin-stats-section-nav/admin-stats-section-nav';
import { getGoogleAnalyticsSectionPath } from '../ga-section-registry/ga-section.registry';

@Component({
  selector: 'admin-google-analytics-account-mode',
  imports: [RouterOutlet, AdminStatsSectionNav],
  templateUrl: './account-mode.html',
  host: { class: 'block h-full w-full min-h-0' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountMode {
  readonly navItems: AdminStatsSectionNavItem[] = [
    { label: 'Dashboard', route: `${getGoogleAnalyticsSectionPath('account-mode')}/dashboard` },
    { label: 'List', route: `${getGoogleAnalyticsSectionPath('account-mode')}/list` },
  ];
}
